export const Institutions = axios => ({
  /**
   * @returns Promise
   */
  get (name) {
    return axios.get(`/v1/institutions?name=${name}`)
  },

  /**
   * @returns Promise
   */
  create (payload) {
    return axios.post('/v1/institutions', payload)
  }
})
